import {
	IPrivacyPolicy,
	ITermsOfService,
} from "../../../models/IPrivacyPolicy";
import api from "../../api";

export const getNotifications = async () => {
	const { data } = await api.get(`administrator/notifications/`);
	return data;
};

export const getNotificationDetails = async (id: number) => {
	const { data } = await api.get(`/administrator/notifications/${id}`);
	return data;
};

export const updateNotifications = async (id: number, params: any) => {
	const { data } = await api.patch(
		`/administrator/notifications/${id}`,
		params
	);
	return data;
};

export const sendTestMail = async (id: number, params: any) => {
	const { data } = await api.post(
		`/administrator/send/notification/${id}`,
		params
	);
	return data;
};

export const getServiceTerms = async () => {
	const { data } = await api.get(`administrator/service_term/`);
	return data as ITermsOfService;
};

export const updateServiceTerms = async (params: any) => {
	const { data } = await api.patch(`administrator/service_term/`, params);
	return data;
};

export const getPrivacyPolitics = async () => {
	const { data } = await api.get(`administrator/privacy/`);
	return data as IPrivacyPolicy;
};

export const updatePrivacyPolitics = async (params: any) => {
	const { data } = await api.patch(`administrator/privacy/`, params);
	return data;
};

export const getIntegrations = async () => {
	const { data } = await api.get(`/integration/list/`);
	return data;
};

export const changeStatusIntegration = async (
	integration: string,
	status: boolean
) => {
	const { data } = await api.post(
		`/integration/action/${integration}/?status=${status}`
	);
	return data;
};
